import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import './App.css';
import { useCart } from './CartContext';
import { bookProducts } from './bookData';
import AddToCartNotification from './AddToCartNotification';

const launchDate = new Date('2026-02-01T00:00:00Z');

function getTimeLeft() {
  const now = new Date();
  const diff = Math.max(launchDate - now, 0);
  const totalHours = Math.floor(diff / (1000 * 60 * 60));
  const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((diff % (1000 * 60)) / 1000);
  return { totalHours, minutes, seconds };
}

function Books() {
  const { addToCart } = useCart();
  const navigate = useNavigate();
  const launchProduct = bookProducts.find((book) => book.isLaunchProduct);
  const regularBooks = bookProducts.filter((book) => !book.isLaunchProduct);
  const [timeLeft, setTimeLeft] = useState(getTimeLeft());
  
  useEffect(() => {
    const timer = setInterval(() => setTimeLeft(getTimeLeft()), 1000);
    return () => clearInterval(timer);
  }, []);
  
  const handleAddToCart = (book) => {
    addToCart(book);
  };
  
  return (
    <div className="main-bg">
      <AddToCartNotification />
      <header className="hero-section">
        <h1 className="site-title">Books & Oracle Decks</h1>
        <p className="site-tagline">Order physical copies of our spiritual books directly from our website.</p>
      </header>
      {launchProduct && (
        <section className="launch-section">
          <div className="launch-media">
            <img src={launchProduct.img} alt={launchProduct.title} className="launch-main-image" />
          </div>
          <div className="launch-details">
            <p className="launch-label">New launch</p>
            <h2>{launchProduct.title}</h2>
            <p className="book-price">${launchProduct.price}</p>
            <p className="book-type">Collector's Edition</p>
            <p className="book-description">{launchProduct.description}</p>
            <div className="launch-timer">
            <div className="launch-countdown">
              <span>{timeLeft.totalHours.toString().padStart(2, '0')}</span>
              <small>Hours</small>
            </div>
              <div className="launch-countdown">
                <span>{timeLeft.minutes.toString().padStart(2, '0')}</span>
                <small>Minutes</small>
              </div>
              <div className="launch-countdown">
                <span>{timeLeft.seconds.toString().padStart(2, '0')}</span>
                <small>Seconds</small>
              </div>
            </div>
            <button
              className="book-btn launch-cta"
              onClick={() => navigate(`/books/${launchProduct.key}`)}
            >
              See Launch Details
            </button>
          </div>
        </section>
      )}
      <div className="books-section">
        <div className="books-list">
          {regularBooks.map((prod) => (
            <div
              className="book-card"
              key={prod.key}
              onClick={() => navigate(`/books/${prod.key}`)}
            >
              <img src={prod.img} alt={prod.title} className="book-img" />
              <h3>{prod.title}</h3>
              <p className="book-type">Physical Copy of book</p>
              <p className="book-price">${prod.price}</p>
              <button 
                className="book-btn" 
                onClick={(event) => {
                  event.stopPropagation();
                  handleAddToCart(prod);
                }}
              >
                Add to Cart
              </button>
              <Link
                to={`/books/${prod.key}`}
                className="book-details-link"
                onClick={(event) => event.stopPropagation()}
              >
                View Details
              </Link>
            </div>
          ))}
        </div>
        <div className="howto-section">
          <h3>How to Order</h3>
          <p>Click "Add to Cart" to add books to your cart. You can review your cart and proceed to checkout to complete your order. All books are physical copies that will be shipped to you.</p>
        </div>
      </div>
      <footer className="footer">
        <p>&copy; {new Date().getFullYear()} Life Force Dynamics. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default Books; 